import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { BenefitsRow } from './BenefitsRow';
import { ClaimsStrapiComponent } from './types';

export const collectClaimsComponentParams = (data: ClaimsStrapiComponent) => {
  return {
    calloutFeatures: data.claims,
  };
};

export const collectClaimsParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof BenefitsRow> | undefined => {
  if (!('claims' in page) || !page.claims) {
    return undefined;
  }

  return {
    component: ReactComponentType.Claims,
    props: collectClaimsComponentParams(page.claims),
  };
};
